import { createSelector } from '@ngrx/store';
import { appSelector } from '../app-selector';

const currentUserSelector = createSelector( appSelector, state => state.currentUser );
export const selectCurrentUserIsFinancialAdvisor = createSelector( currentUserSelector, state => state?.isFinancialAdvisor || null );

